// document.addEventListener('touchstart', onTouchStart, {passive: true});

$(document).ready(function () {
    console.log("ready");

    $(".slider-intro-text").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".slider-intro-img",
        speed: 500,
        autoplaySpeed: 3000,
    });
    $(".slider-intro-img").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".slider-intro-text",
        dots: true,
        centerMode: false,
        focusOnSelect: true,
        autoplay: false,
        speed: 1500,
        autoplaySpeed: 3000,
    });

    $("ol").each(function (ol_index, ol) {
        $(ol)
            .find("li")
            .each(function (index, element) {
                $(this).attr("data-content", index + 1);
            });
    });

    $('<span class="union"></span> ').prependTo("a.btn.btn-primary");
    $('<span class="mdi mdi-send"></span> ').prependTo(
        "button.btn.btn-primary"
    );

    $(".accordion").each(function (index, element) {
        $(element).on("shown.bs.collapse", function () {
            $(this).addClass("opened");
            $(this).removeClass("opening");
        });
        $(element).on("show.bs.collapse", function () {
            $(this).addClass("opening");
            $(".accordion.opened").find(".show").collapse("hide");
        });
        $(element).on("hide.bs.collapse", function () {
            $(this).removeClass("opened");
        });
    });

    $(".contact-box").wrapInner('<div class="inner">');

    var hr_lg_count = 0;
    var hr_md_count = 0;

    $("body.produkte .ce_text.produkte").each(function () {
        hr_lg_count++;
        hr_md_count++;

        if (hr_md_count == 2) {
            $(
                '<div class="col-12 d-none d-md-block d-lg-none hr_md"><hr></div>'
            ).insertAfter(this);
            hr_md_count = 0;
        }

        if (hr_lg_count == 3) {
            $(
                '<div class="col-12 d-none d-lg-block hr_lg"><hr></div>'
            ).insertAfter(this);
            hr_lg_count = 0;
        }
    });

    $("a").each(function () {
        if ($(this).data("href")) {
            $(this).click(function (e) {
                e.preventDefault();
                console.log($(this).data("href"));

                $([document.documentElement, document.body]).animate({
                    scrollTop: $($(this).data("href")).offset().top
                }, 1000);
            });
        }
    });
});
